<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Bodegas
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Maestros</span>
      <span> /</span>
      <span>Bodegas</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-header justify-content-end" style="border-bottom: 1px solid #dee2e6">
      <div></div>
      <button type="button" mdbBtn color="info" data-target="#basicExample"
        (click)="muestraModalAgrega(); showModalAgregar()" mdbWavesEffect size="sm">
        Agregar
      </button>
    </div>

    <div class="row filtros-body">
      <div class="col">
        <!-- Material inline 1 -->
        <div class="form-check form-check-inline">
          <input type="radio" class="form-check-input" id="materialInline1" name="inlineMaterialRadiosExample"
            [(ngModel)]="busquedaEstado" [value]="1" checked mdbInput />
          <label class="form-check-label" for="materialInline1">Activos</label>
        </div>

        <!-- Material inline 2 -->
        <div class="form-check form-check-inline">
          <input type="radio" class="form-check-input" id="materialInline2" name="inlineMaterialRadiosExample"
            [(ngModel)]="busquedaEstado" [value]="2" mdbInput />
          <label class="form-check-label" for="materialInline2">Inactivos</label>
        </div>

        <div class="form-check form-check-inline">
          <input type="radio" class="form-check-input" id="materialInline3" name="inlineMaterialRadiosExample"
            [(ngModel)]="busquedaEstado" [value]="3" mdbInput />
          <label class="form-check-label" for="materialInline3">Todos</label>
        </div>
      </div>
    </div>
  </div>
  <!-- FOOTER -->
  <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
    <div></div>
    <button mdbBtn type="button" color="secondary" (click)="filtraxEstado()" size="sm" mdbWavesEffect>
      <mdb-icon fas icon="search"></mdb-icon>
      Buscar
    </button>
  </div>
</div>

<div class="card mb-2 wow">
  <!--Card content-->
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Nombre</th>
            <th scope="col">Descripcion</th>
            <th scope="col">Bodega Principal</th>
            <th scope="col">Estado</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let bod of listaBodega">
            <td>{{ bod.nombre }}</td>
            <td>{{ bod.descripcion }}</td>
            <td>
              <div *ngIf="bod.principal">
                <mdb-badge pill="true" success="true">Principal</mdb-badge>
              </div>
            </td>
            <td>
              <div *ngIf="bod.activo">
                <mdb-badge pill="true" success="true">Activo</mdb-badge>
              </div>
              <div *ngIf="!bod.activo">
                <mdb-badge pill="false" warning="true">Inactivo</mdb-badge>
              </div>
            </td>
            <td>
              <button class="btn-actions-sm" color="info" mdbBtn type="button" size="sm" mdbWavesEffect
                data-toggle="modal" data-target="#basicExample" (click)="showModalModificar(); showForEdit(bod)"
                mdbTooltip="Editar" placement="right">
                <mdb-icon fas icon="pen"></mdb-icon>
              </button>
              <button *ngIf="!bod.activo" class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect
                (click)="permitirCambioEstado(bod)" mdbTooltip="Activar" placement="right">
                <mdb-icon fas icon="ban"></mdb-icon>
              </button>
              <button *ngIf="bod.activo" class="btn-actions-sm" color="success" mdbBtn type="button" mdbWavesEffect
                (click)="permitirCambioEstado(bod)" mdbTooltip="Desactivar" placement="right">
                <mdb-icon fas icon="check"></mdb-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!--Modal de Creacion de Bodegas-->
<div mdbModal #centralLarge="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <form [formGroup]="formAgregarBodega">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">Agregar</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="centralLarge.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="">
            <div class="row">
              <div class="col">
                <h5>Datos bodega</h5>
              </div>
              <div class="col">
                <div class="switch info-switch">
                  <label>Inactivo<input class="form-check-input" type="checkbox" id="activo" formControlName="activo" />
                    <span class="lever"></span>Activo</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="md-form">
                  <input value="0" id="codigo" name="codigo" class="form-control" placeholder="ID" type="hidden"
                    #codigo />
                  <input value="0" id="rut_empresa" name="rut_empresa" class="form-control" placeholder="ID"
                    type="hidden" #rut_empresa />
                  <input value="0" id="sucursal_codigo" name="sucursal_codigo" class="form-control" placeholder="ID"
                    type="hidden" #sucursal_codigo />
                </div>
                <div class="md-form">
                  <input placeholder="Nombre" class="form-control" type="text" id="nombre" formControlName="nombre" />

                  <label for="nombre">Nombre <span class="text-danger">(*)</span></label>
                  <div *ngIf="
                      frmAgregaNombre.invalid &&
                      (frmAgregaNombre.dirty || frmAgregaNombre.touched)
                    ">
                    <mdb-error *ngIf="frmAgregaNombre.errors.required">
                      El nombre es requerido
                    </mdb-error>
                    <mdb-error *ngIf="frmAgregaNombre.errors.maxlength">
                      El nombre no puede superar los 20 caracteres
                    </mdb-error>
                    <mdb-error *ngIf="frmAgregaNombre.errors.minlength">
                      El nombre debe tener como mínimo 5 caracteres
                    </mdb-error>
                  </div>
                </div>

                <div class="md-form">
                  <input placeholder="Descripción" class="form-control" type="text" id="descripcion"
                    formControlName="descripcion" />
                  <label for="descripcion">Descripción <span class="text-danger">(*)</span></label>
                  <div *ngIf="
                      frmAgregaDescripcion.invalid &&
                      (frmAgregaDescripcion.dirty ||
                        frmAgregaDescripcion.touched)
                    ">
                    <mdb-error *ngIf="frmAgregaDescripcion.errors.required">
                      La descripción es requerida
                    </mdb-error>
                    <mdb-error *ngIf="frmAgregaDescripcion.errors.maxlength">
                      El nombre no puede superar los 150 caracteres
                    </mdb-error>
                    <mdb-error *ngIf="frmAgregaDescripcion.errors.minlength">
                      El nombre debe tener como mínimo 5 caracteres
                    </mdb-error>
                  </div>
                </div>
                <div class="md-form">
                  <input placeholder="Observaciones" class="form-control" type="text" id="observaciones"
                    formControlName="observaciones" />
                  <label for="observaciones">Observaciones</label>
                  <div *ngIf="
                      frmAgregaObservaciones.invalid &&
                      (frmAgregaObservaciones.dirty ||
                        frmAgregaObservaciones.touched)
                    ">
                    <mdb-error *ngIf="frmAgregaObservaciones.errors.maxlength">
                      El nombre no puede superar los 200 caracteres
                    </mdb-error>
                  </div>
                </div>

                <div class="switch info-switch">
                  Bodega Principal<br />
                  <label>No
                    <input class="form-check-input" type="checkbox" id="aprincipal" formControlName="principal" />
                    <span class="lever"></span>Si</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="centralLarge.hide()"
            mdbWavesEffect>
            Cerrar
          </button>
          <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect
            [disabled]="!formAgregarBodega.valid" (click)="insertar(); centralLarge.hide()">
            Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!--Modal de Edición de Bodegas-->
<div mdbModal #editarBodega="mdb-modal" class="modal fade" id="basicExamplex" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <form [formGroup]="formEditarBodega">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">
            Editar Bodega
          </h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="editarBodega.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <input id="codigox" formControlName="codigo" class="form-control" type="hidden" />
          <input id="rut_empresax" class="form-control" type="hidden" formControlName="rut_empresa" />
          <input id="sucursal_codigox" class="form-control" type="hidden" formControlName="sucursal_codigo" />

          <div class="row">
            <div class="col">
              <h5>Datos bodega</h5>
            </div>
            <div class="col">
              <div class="switch info-switch">
                <label>Inactivo<input class="form-check-input" type="checkbox" id="activox" formControlName="activo" />
                  <span class="lever"></span>Activo</label>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="md-form">
                <input placeholder="Nombre" class="form-control" type="text" id="nombrex" formControlName="nombre" />
                <label for="nombrex">Nombre <span class="text-danger">(*)</span></label>
                <div *ngIf="
                    frmEditarNombre.invalid &&
                    (frmEditarNombre.dirty || frmEditarNombre.touched)
                  ">
                  <mdb-error *ngIf="frmEditarNombre.errors.required">
                    El nombre es requerido
                  </mdb-error>
                  <mdb-error *ngIf="frmEditarNombre.errors.maxlength">
                    El nombre no puede superar los 20 caracteres
                  </mdb-error>
                  <mdb-error *ngIf="frmEditarNombre.errors.minlength">
                    El nombre debe tener como mínimo 5 caracteres
                  </mdb-error>
                </div>
              </div>
              <div class="md-form">
                <input placeholder="descripcion" class="form-control" type="text" id="descripcionx"
                  formControlName="descripcion" />
                <label for="descripcionx">Descripcion <span class="text-danger">(*)</span></label>
                <div *ngIf="
                    frmEditarDescripcion.invalid &&
                    (frmEditarDescripcion.dirty || frmEditarDescripcion.touched)
                  ">
                  <mdb-error *ngIf="frmEditarDescripcion.errors.required">
                    La descripción es requerida
                  </mdb-error>
                  <mdb-error *ngIf="frmEditarDescripcion.errors.maxlength">
                    El nombre no puede superar los 150 caracteres
                  </mdb-error>
                  <mdb-error *ngIf="frmEditarDescripcion.errors.minlength">
                    El nombre debe tener como mínimo 5 caracteres
                  </mdb-error>
                </div>
              </div>

              <div class="switch info-switch">
                Bodega Principal<br />
                <label>No
                  <input class="form-check-input" type="checkbox" id="principal" formControlName="principal" />
                  <span class="lever"></span>Si</label>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="editarBodega.hide()"
              mdbWavesEffect>
              Cerrar
            </button>
            <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect
              [disabled]="!formEditarBodega.valid" (click)="actualizar(); editarBodega.hide()">
              Guardar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>